import * as types from './mutations-types';
import { API, graphqlOperation } from 'aws-amplify';
import { createDataExtractionRequest } from '../../../graphql/mutations';
import { getCurUser } from '../../../constants/fromLocalStorageConstants';
import { logError } from '@/utils/loggerUtils';

const extractRequestStatus = 'RECEIVED';

export const actions = {
  async requestExtractData(
    { commit },
    { documentID, type, additionalComments, annotations }
  ) {
    const { email, name } = getCurUser();

    commit(types.EXTRACT_REQUEST_STARTED);
    const request = {
      username: email,
      name,
      documentID,
      type,
      additionalComments,
      annotations,
      status: extractRequestStatus,
    };
    try {
      await API.graphql(
        graphqlOperation(createDataExtractionRequest, {
          input: request,
        })
      );
      commit(types.EXTRACT_REQUEST_SUCCESS);
    } catch (error) {
      commit(types.EXTRACT_REQUEST_FAILURE, { error });
      logError(error);
    }
  },
};
